<template>
  <portal to="app-portal-dialog">
    <el-dialog
      :visible.sync="isDialogVisible"
      v-bind="$attrs"
    >
      <div class="dialog-content">
        <!-- 如果有 slot，顯示 slot，否則顯示 message -->
        <slot>
          <span>{{ message }}</span>
        </slot>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="showCancelButton"
          round
          @click="handleCancel"
        >{{ cancelButtonText }}</el-button>
        <el-button
          type="primary"
          round
          @click="handleConfirm"
        >{{ confirmButtonText }}</el-button>
      </span>
    </el-dialog>
  </portal>
</template>

<script>
export default {
  name: 'MessageDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    message: {
      type: String
    },
    showCancelButton: {
      type: Boolean
    },
    cancelButtonText: {
      type: String
    },
    confirmButtonText: {
      type: String
    },
    onConfirm: {
      type: Function
    },
    onCancel: {
      type: Function
    }
  },
  data () {
    return {
      isDialogVisible: false
    }
  },
  watch: {
    visible (newVal) {
      this.isDialogVisible = newVal
    }
  },
  methods: {
    handleConfirm () {
      if (this.onConfirm) {
        this.onConfirm()
      } else {
        this.$emit('confirm')
      }
    },
    handleCancel () {
      if (this.onCancel) {
        this.onCancel()
      } else {
        this.$emit('cancel')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  @include basicDialog();
  .el-dialog__header {
    padding: 16px 40px;
  }
  .el-dialog__body {
    overflow-y: unset;
    font-size: map-get($fontSize, 'medium');
    line-height: 1.5;
    padding: 30px 40px 10px 40px;
  }
  .el-dialog__footer {
    border-top: unset;
    text-align: center;
    padding: 20px 0;
  }
}
</style>
